module.exports = __webpack_public_path__ + "media/images/badges/akt/AKT_BadassLoyaltyProgram_InvertedBadges_116x116_5-90dc40c77c6b08dff22ec53fe52496ff.png";